/** HeadlessUI Transition component */

export const defaultEnterTransitionProps = {
  enter: 'transform ease-out duration-500 transition',
  enterFrom: 'opacity-0',
  enterTo: 'opacity-100',
};
